import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
//import * as createjs from 'createjs-module'
//import LZString from 'lz-string'
 
let createjs = window.createjs;

export default class Snowflake extends Component {

    MODE_DRAW = "draw"
    MODE_VIEW = "view"
    BG_MODE_OPAQUE = "opaque"
    BG_MODE_TRANSPARENT = "transparent"
    //createjs = require('createjs');
    constructor(props) {
        super(props)
        //Snowflaker.createjs = window.createjs;
        //console.log(window.createjs);
        //define all of the private variables that do not cause a rerender
        this.initialScale = 0
        this.loaded = false;
        this.stage = null;
        this.previewContainer = null;
        this.drawPadding = 40;
        this.viewPadding = 20;
        this.backgroundShape = null;
        this.previewSnowflakeContainer = null;
        this.drawContainer = null;
        this.isDrawing = false;
        this.shapeCanvas = null;
        this.drawingCanvas = null;
        this.oldPt = null;
        this.image = null;
        this.bitmap = null;
        this.maskFilter = null;
        this.mapFilter = null;
        this.cursor = null;
        this.line = null;
        this.pendingLine = null;
        this.showPreview = false;
        this.points = [];
        this.allPoints = [];
        this.mouseIsDown = false;
        this.initialized = false;
        this.ignoreNextPropsChange = false;
        this.notify = false;
        this.state = {
            pointData: '',
            getDataUrlFunc: this.getDataUrl(this)
        }
    }

    //define the puplic properties
    static propTypes = {
        mode: PropTypes.string.isRequired,
        bgMode: PropTypes.string,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        initialData: PropTypes.string
    }
    
   
    handleImageLoaded() {
        console.log('image loaded')
        this.loaded = true
        // Init CreateJS
        var canvas = ReactDOM.findDOMNode(this.refs.canvas)
        this.stage = new createjs.Stage(canvas);
        //createjs.Ticker.addEventListener('tick', this.stage);
        //createjs.Ticker.setFPS(45);

        this.drawContainer = new createjs.Container();
        
        this.previewContainer = new createjs.Container().set({ x: 0 });
        this.previewSnowflakeContainer = new createjs.Container().set({ x: 0 });

        this.backgroundShape = new createjs.Shape(new createjs.Graphics());
        this.stage.addChild(this.backgroundShape)

        this.previewContainer.addChild(this.previewSnowflakeContainer);


        //this.stage.canvas.width = window.innerWidth;
        //this.stage.canvas.height = window.innerHeight;
        this.stage.update();

        
        //console.log(this.stage)
        createjs.Touch.enable(this.stage, false, true);
        //this.stage.enableMouseOver()
        this.image = ReactDOM.findDOMNode(this.refs.image)
        this.shapeCanvas = new createjs.Shape();
        this.shapeCanvas.graphics = new createjs.Graphics()
            .beginFill("rgba(255,255,255,1)")
            .moveTo(0, 0).lineTo(this.image.width, 0).lineTo(864, 503)
        this.shapeCanvas.cache(0, 0, this.image.width, this.image.height)

        this.bitmap = new createjs.Bitmap(this.image);
        this.maskFilter = new createjs.AlphaMaskFilter(this.shapeCanvas.cacheCanvas);

        this.drawingCanvas = new createjs.Shape(this.getDrawingCanvasShape());

        this.drawingCanvas.cache(0, 0, this.image.width, this.image.height);

        this.bitmap.filters = [this.maskFilter];
        this.bitmap.shadow = new createjs.Shadow("#000000", 0, 0, 10);
        this.bitmap.cache(0, 0, this.image.width, this.image.height);
        var cache2 = this.bitmap.cacheCanvas;
        var folds = 12;
        var rot = 360 / folds;
        var scale = 1;
        var offset = this.image.width * scale + (this.viewPadding);//this.image.width * scale + 50;
        for (var i = 0; i < folds; i++) {
            var b = new createjs.Bitmap(cache2);
            var isFirst = ((i % 2) === 0);
            b.set({ x: offset, y: offset, scaleX: scale, scaleY: scale * (isFirst ? 1 : -1), rotation: rot * (isFirst ? i - 1 : i), alpha: isFirst ? .75 : 1 });// 

            this.previewSnowflakeContainer.addChild(b);
        }
        this.previewSnowflakeContainer.cache(0, 0, this.stage.width, this.stage.height);
        this.previewContainer.shadow = new createjs.Shadow("#222", 0, 0, 10);

        this.drawContainer.addChild(this.bitmap);
        //this.stage.addChild(previewContainer);
        this.cursor = new createjs.Shape(new createjs.Graphics().beginFill("rgba(50, 200, 200, 1)").drawCircle(0, 0, 5));
        this.cursor.cursor = "pointer";

        this.drawContainer.addChild(this.cursor);

        this.line = new createjs.Shape(this.getLineGraphics());
        this.drawContainer.addChild(this.line)

        this.pendingLine = new createjs.Shape(this.getLineGraphics());
        this.drawContainer.addChild(this.pendingLine)
        
        //this.handleMouseDown = this.handleMouseDown.bind(this);
        //this.handleMouseUp = this.handleMouseUp.bind(this);
        //this.handleMouseDblClick = this.handleMouseDblClick.bind(this);
        //this.handleMouseMove = this.handleMouseMove.bind(this);
        //this.handleKeyEvent = this.handleKeyEvent.bind(this);

        //this.drawContainer.addEventListener("click", this.handleMouseDown);
        //this.stage.addEventListener("stagemousedown", this.handleMouseDown);
        //this.stage.addEventListener("stagemouseup", this.handleMouseUp);
        //this.drawContainer.addEventListener("dblclick", this.handleMouseDblClick);
        var isTouchDevice = 'ontouchstart' in document.documentElement;
        this.touch1 = null
        this.touch2 = null
        this.zoom = 1;
        this.lastPos = null;
        this.dragging = false;
        this.stage.on("mousedown", this.handleMouseDown.bind(this));
        this.stage.on("pressup", this.handlePressup.bind(this));
        this.stage.on("pressmove", this.handlePressmove.bind(this));
        if (!isTouchDevice) {
            this.stage.addEventListener("stagemousemove", this.handleMouseMove.bind(this));
        }
        document.addEventListener("keydown", this.handleKeyEvent.bind(this));
        this.stage.canvas.addEventListener("mousewheel", this.handleMouseWheel.bind(this), false);
        this.stage.canvas.addEventListener("DOMMouseScroll", this.handleMouseWheel.bind(this), false);

        //fade in 
        this.drawContainer.alpha = 0;
        createjs.Tween.get(this.drawContainer)
            .to({ alpha: 1 },1000).addEventListener("change", function () { this.stage.update() }.bind(this));

        this.draw();
    }

    ///events//////
    handleMouseDown(evt) {
        console.log('touch', evt)
        if (evt.pointerID === 0 || evt.pointerID === -1 || evt.primary) { //touch 1 or mouse
            this.touch1 = new createjs.Point(this.stage.globalToLocal(evt.stageX, 0).x, this.stage.globalToLocal(0, evt.stageY).y);
            //console.log('touch 1')
        } else if (evt.pointerID === 1 || !evt.primary) { //touch 2
            this.touch2 = new createjs.Point(this.stage.globalToLocal(evt.stageX, 0).x, this.stage.globalToLocal(0, evt.stageY).y);
            //.log('touch 2')
        }
        this.lastPos = new createjs.Point(this.drawContainer.x, this.drawContainer.y)
    }
    handlePressup(evt) {
        var newPos = new createjs.Point(this.drawContainer.x, this.drawContainer.y)
        var dist = this.distanceP(this.lastPos, newPos);
        console.log(dist)
        if (!this.touch2 && dist < 5) {
            this.handleMouseDownForDraw(evt)
        }
        this.lastPos = newPos
        this.dragging = false
        if (evt.pointerID === 0 || evt.pointerID === -1 || evt.primary) { //touch 1 or mouse
            this.touch1 = null;
        } else if (evt.pointerID === 1 || !evt.primary) { //touch 2
            this.touch2 = null;
        }
    }
    handlePressmove(evt) {
        //dragging = true;
        //console.log('pressmove')
        var touch = null;
        if (evt.pointerID === -1 || evt.pointerID === 0 || evt.primary) {
            touch = this.touch1;
        } else if (evt.pointerID === 1 || !evt.primary) {
            touch = this.touch2;
        }
        if (touch === null) { return }
        //console.log(evt.stageX, touch)
        var dX = this.stage.globalToLocal(evt.stageX, 0).x - touch.x;
        var dY = this.stage.globalToLocal(0, evt.stageY).y - touch.y;

        if (this.touch1 && this.touch2) var oldDist = this.distanceP(this.touch1, this.touch2);

        touch.x += dX;
        touch.y += dY;

        //if both fingers are used zoom and move the canvas
        if (this.touch1 && this.touch2) {
            var newDist = this.distanceP(this.touch1, this.touch2);
            //console.log(newDist)
            var newZoom = 1 * newDist / oldDist;
            this.zoomMap(newZoom, new createjs.Point((this.touch1.x + this.touch2.x) / 2, (this.touch1.y + this.touch2.y) / 2))

            //if both fingers are used apply only half of the motion to each of them
            dX /= 2;
            dY /= 2;
        }

        this.drawContainer.x += dX;
        this.drawContainer.y += dY;
        this.keepInView();
        this.stage.update();
    }
    handleMouseWheel(e) {
        var newZoom = 1;
        if (Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail))) > 0)
            newZoom *= 1.1;
        else
            newZoom *= 1 / 1.1;
        var local = this.stage.globalToLocal(this.stage.mouseX, this.stage.mouseY);
        this.zoomMap(newZoom, local)//new createjs.Point(stage.globalToLocal(e.stageX, e.stageY)))//new createjs.Point(e.stageX, e.stageY))
        this.keepInView()
        this.stage.update();
    }
    //////////////
    //perspective controls//////////////
    distanceP(p1, p2) {
        return Math.sqrt((p2.x - p1.x) * (p2.x - p1.x) + (p2.y - p1.y) * (p2.y - p1.y));
    }

    zoomMap(newZoom, zoomCenter) {
        //console.log(newZoom)
        var setPos = true;
        this.zoom *= newZoom
        
        
        var minZoomX = (this.stage.canvas.width - this.drawPadding) / this.image.width;    
        var minZoomY = (this.stage.canvas.height - this.drawPadding) / this.image.height;
        var minZoom = Math.min(1, minZoomX, minZoomY)
        if (this.zoom < minZoom) {
            newZoom = 1
            this.zoom = minZoom
            setPos = false
        }
        if (this.zoom > 3) {
            newZoom = 1
            this.zoom = 3
            setPos = false
        }
        this.drawContainer.scale = this.zoom
        if (!setPos) { return }
        zoomCenter = this.drawContainer.globalToLocal(zoomCenter.x, zoomCenter.y)
        this.drawContainer.x += (1 - newZoom) * zoomCenter.x * this.zoom//* (zoomCenter.x -(this.drawContainer.x/2) )
        this.drawContainer.y += (1 - newZoom) * zoomCenter.y * this.zoom//* (zoomCenter.y+this.drawContainer.y)

        
    }
    keepInView() {
        var ext = this.drawContainer.localToGlobal(this.image.width, this.image.height)

        if (this.image.width * this.drawContainer.scale < this.stage.canvas.width ) {
            //center
            this.drawContainer.x = this.stage.canvas.width / 2 - this.image.width * this.drawContainer.scale / 2
        } else {
            if (this.drawContainer.x > this.drawPadding) { this.drawContainer.x = this.drawPadding }
            if (ext.x < this.stage.canvas.width - this.drawPadding) { this.drawContainer.x = (this.stage.canvas.width - this.drawPadding) - (this.drawContainer.scale * this.image.width) }
        }

        if (this.image.height * this.drawContainer.scale < this.stage.canvas.height) {
            //center
            this.drawContainer.y = this.stage.canvas.height / 2 - this.image.height * this.drawContainer.scale / 2
        } else {
            if (this.drawContainer.y > this.drawPadding) { this.drawContainer.y = this.drawPadding }
            if (ext.y < this.stage.canvas.height - this.drawPadding) { this.drawContainer.y = (this.stage.canvas.height - this.drawPadding) - (this.drawContainer.scale * this.image.height) }
        }
    }

    /////////////
    componentWillUnmount() {
        createjs.Touch.disable(this.stage);
        if (this.drawContainer) {
            this.drawContainer.removeEventListener("mousedown", this.handleMouseDown);
            this.drawContainer.removeEventListener("dblclick", this.handleMouseDblClick);
        }
        if (this.stage) {
            this.stage.removeEventListener("stagemouseup", this.handleMouseUp);
            this.stage.removeEventListener("stagemousemove", this.handleMouseMove);
        }
        document.removeEventListener("keydown", this.handleKeyEvent);
    }
    /**
     * New Properties are received.
     * Remove previous Chart and draw a new one
     * @param nextProps
     */
    componentWillReceiveProps(nextProps) {
        //this.hidePreviousChart(nextProps.data);
        if (this.ignoreNextPropsChange) {
            this.ignoreNextPropsChange = false
        } else {
            this.draw(nextProps)
        }
    }

    getDrawingCanvasShape() {
        return new createjs.Graphics()
            .beginFill("#FFF")
            .drawRect(0, 0, this.image.width, this.image.height)
    }
    
    /**
     * Draw a new chart
     * @param data
     */
    draw(props) {
        props = props || this.props;
        //console.log('image loaded',this.loaded)
        if (!this.loaded) { return }
        
        if (this.state.pointData !== props.pointData) {
            this.setState({ pointData: props.pointData }); 
            this.load(props.pointData);
        }
        this.stage.canvas.width = props.width;
        this.stage.canvas.height = props.height;

        this.backgroundShape.graphics.clear()
        if (!props.bgMode || props.bgMode === this.BG_MODE_OPAQUE) {
            this.backgroundShape.graphics.beginFill('#333').drawRect(0, 0, this.stage.canvas.width, this.stage.canvas.height).endFill();
        }
        if (props.mode === this.MODE_DRAW) {
            this.stage.removeChild(this.previewContainer);
            this.stage.addChild(this.drawContainer);
            this.drawContainer.scale = 1;
            if (this.stage.canvas.width - this.drawPadding < this.image.width * this.drawContainer.scale) {
                this.drawContainer.scale = (this.stage.canvas.width - this.drawPadding) / this.image.width;
            }
            if (this.stage.canvas.height - this.drawPadding < this.image.height * this.drawContainer.scale) {
                this.drawContainer.scale = (this.stage.canvas.height - this.drawPadding) / this.image.height;
            }
            this.drawContainer.set({ x: this.stage.canvas.width / 2 - this.image.width * this.drawContainer.scale / 2, y: this.stage.canvas.height / 2 - this.image.height * this.drawContainer.scale / 2 })
            //console.log("this.bitmap.scale - " + this.bitmap.scale)
        }
        if (props.mode === this.MODE_VIEW) {
            this.stage.addChild(this.previewContainer);
            this.stage.removeChild(this.drawContainer);
            var smallestSide = Math.min(this.stage.canvas.width, this.stage.canvas.height);
            var scale = (smallestSide - this.viewPadding) / (this.image.width * 2);
            this.previewSnowflakeContainer.scale = scale;
            var width = this.stage.canvas.width / scale
            var height = this.stage.canvas.height / scale
            this.previewSnowflakeContainer.cache(0, 0, width, height);
            var x = (this.stage.canvas.width / 2) - (this.image.width * scale) - this.viewPadding * scale
            var y = (this.stage.canvas.height / 2) - (this.image.width * scale) - this.viewPadding * scale
            this.previewSnowflakeContainer.set({ x: x , y: y })
        }

        
            
        
        this.stage.update();

        //console.log(ctx.getImageData(0, 0, 300, 300));
    }

    shouldComponentUpdate(nextProps, nextState) {
        return false 
    }

    //event listeners/////////////////////////
    handleMouseDownForDraw(event) {
        //console.log('handleMouseDown')
        this.mouseIsDown = true;
        
        var p = this.drawContainer.globalToLocal(event.stageX, event.stageY);
        //var dY = this.stage.globalToLocal(0, ).y;
        this.oldPt = new createjs.Point(p.x, p.y)//new createjs.Point(this.stage.mouseX, this.stage.mouseY);

        if (this.points.length === 0) {
            this.isDrawing = true;
            var graphics = new createjs.Graphics().beginFill("rgba(50, 200, 200, 1)").drawCircle(this.oldPt.x, this.oldPt.y, 10).endFill();
            this.line.graphics = this.getLineGraphics(graphics).moveTo(this.oldPt.x, this.oldPt.y)

        } else if (this.dist(this.points[0], this.oldPt) < 20) {
            //done
            this.finishFill();
            return;
        } else {
            this.line.graphics.lineTo(this.oldPt.x, this.oldPt.y)
        }
        this.points.push(this.oldPt);
        this.handleMouseMove(event)
    }

    handleMouseMove(event) {
        if (this.ignoreMouseEvents) { return; }
        var p = this.drawContainer.globalToLocal(this.stage.mouseX, this.stage.mouseY);
        this.cursor.x = p.x;
        this.cursor.y = p.y;
        if (!this.isDrawing) {
            this.stage.update();
            return;
        }
        this.pendingLine.graphics = this.getLineGraphics().moveTo(this.oldPt.x, this.oldPt.y).lineTo(this.cursor.x, this.cursor.y);
        //if (this.mouseIsDown && (this.dist(this.oldPt, this.cursor) > 20)) {
        //    //fire a mouse down
        //    this.handleMouseDown(event);
        //}
        this.stage.update();

    }

    handleMouseDblClick() {
        this.finishFill();
    }

    handleMouseUp(event) {
        this.mouseIsDown = false;
    }

    handleKeyEvent(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
            this.points = [];
            this.line.graphics = this.getLineGraphics();
            this.pendingLine.graphics = this.getLineGraphics();
            this.isDrawing = false;
        }
    }

    //helpers///////////////
    load(data) {
        if (data !== null) {
            this.drawingCanvas.graphics = this.getDrawingCanvasShape();
            this.drawingCanvas.updateCache();
            this.updateCanvas();
            
            console.log("loading data - " + data)

            this.allPoints = this.deserialize(data);
            for (var i = 0; i < this.allPoints.length; i++) {
                this.cutMask(this.allPoints[i]);
            }
            this.saveToAllPoints();
        }
    }

    finishFill() {
        //console.log(this.points.length)
        if (this.points.length <= 2) {
            this.points = [];
        }
        this.points = this.shiftPoints(this.points);
        this.cutMask(this.points);
        this.saveToAllPoints(this.points);
        this.line.graphics = this.getLineGraphics();
        this.pendingLine.graphics = this.getLineGraphics();

        this.stage.update();
        this.isDrawing = false;
    }

    shiftPoints(pts) {
        for (var i = 0; i < pts.length; i++) {
            pts[i].x = Math.round((pts[i].x - this.bitmap.x) / this.bitmap.scale);
            pts[i].y = Math.round((pts[i].y - this.bitmap.y) / this.bitmap.scale);
        }
        return pts;
    }


    cutMask(pts) {
        if (pts === null || pts.length === 0){ return }
        var g = this.drawingCanvas.graphics
            .setStrokeStyle(1, "round", "round")
            .beginStroke("rgba(0,0,0,1)")
            .beginFill("rgba(0,0,0,1)")
            .moveTo(pts[0].x, pts[0].y)

        for (var i = 1; i < pts.length; i++) {
            g.lineTo(pts[i].x, pts[i].y);
        }

        this.updateCanvas();

    }
    updateCanvas() {
        this.drawingCanvas.updateCache("source-over");
        this.mapFilter = new createjs.AlphaMapFilter(this.drawingCanvas.cacheCanvas);
        this.bitmap.filters = [this.mapFilter, this.maskFilter];
        this.bitmap.updateCache();
        this.previewSnowflakeContainer.updateCache();
        this.stage.update();
    }

    saveToAllPoints(pts) {
        if (pts && pts.length > 0) {
            this.allPoints.push(pts)
        }
        this.points = []
        //serialize
        var str = this.serialize(this.allPoints)
        //console.log(str);
        this.setState({ pointData: str })
        if (this.props.onDataChange) {
            //var ctx = this.stage.canvas.getContext('2d');
           //console.log('ondatachange')
            this.ignoreNextPropsChange = true;
            setTimeout(function () { 
                this.props.onDataChange(this.state.pointData, this.getDataUrl(this))
            }.bind(this),10)
        }
    }
    //used to lazy load the bytes
    getDataUrl(self) {
        return function () {
            self.stage.update();
            return self.stage.canvas.toDataURL();
        }
    }

    getLineGraphics(graphics) {
        if (!graphics) { graphics = new createjs.Graphics() }
        return graphics.setStrokeStyle(3, "round", "round").beginStroke("rgba(50, 200, 200, 1)")
    }

    serialize(pts) {
        var str = "";
        for (var i = 0; i < pts.length; i++) {
            str += ":";
            var ps = pts[i];
            for (var j = 0; j < ps.length; j++) {

                str += ps[j].x + "," + ps[j].y;
                if (j < ps.length - 1) { str += ","; }
            }
        }
        //str = LZString.compressToEncodedURIComponent(str);
        return str;
    }

    deserialize(str) {
        var pts = [];
        str = str ? str : "";
        //str = LZString.decompressFromEncodedURIComponent(str);
        var fills = str.split(':');
        if (fills.length > 0) {
            fills.shift();
        }
        for (var i = 0; i < fills.length; i++) {
            var f = fills[i].split(',');
            var ptarr = [];
            for (var j = 0; j < f.length; j++) {
                var x = parseInt(f[j], 10);
                var y = parseInt(f[j + 1], 10);
                j++;
                ptarr.push(new createjs.Point(x, y))
            }
            pts.push(ptarr);
        }
        return pts;
    }

    dist(p1, p2) {

        var a = p1.x - p2.x;
        var b = p1.y - p2.y;

        var c = Math.sqrt(a * a + b * b);
        return c;
    }
    

    /**
     * Render Function
     * @returns {XML}
     */
    render() {
        return (
            <div className='snowflake' style={this.props.style}>
                <div className='canvas-scroll'></div>
                <canvas ref="canvas"
                        width={this.props.width}
                        height={this.props.height}></canvas>
                <img ref="image" alt="loader" style={{ display: 'none' }} src={process.env.PUBLIC_URL + '/images/folded-paper.png'} onLoad={this.handleImageLoaded.bind(this)}
                    />
            </div>
        );
    }


}



// WEBPACK FOOTER //
// ./src/components/Snowflake/index.js